/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FilePenLine = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m18 5-3-3H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" }],
    ["path", { d: "M8 18h1" }],
    ["path", { d: "M18.4 9.6a2 2 0 1 1 3 3L17 17l-4 1 1-4Z" }]
  ]
];

export { FilePenLine as default };
//# sourceMappingURL=file-pen-line.js.map
